
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'AboutUS',
  setup(props, ctx) {
    return {};
  },
});
